import { render, staticRenderFns } from "./CollapsableCard.vue?vue&type=template&id=cbc9e5da&scoped=true&"
import script from "./CollapsableCard.vue?vue&type=script&lang=js&"
export * from "./CollapsableCard.vue?vue&type=script&lang=js&"
import style0 from "./CollapsableCard.vue?vue&type=style&index=0&id=cbc9e5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc9e5da",
  null
  
)

export default component.exports